import {
  Badge,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useColorModeValue,
} from '@chakra-ui/react';
import Card from 'components/card/Card';
import { SubscriptionPlanFeature } from 'services/@types';

interface FeaturesTableProps {
  features: SubscriptionPlanFeature[];
}

export default function FeaturesTable({ features }: FeaturesTableProps) {
  const textColor = useColorModeValue('secondaryGray.900', 'white');
  const borderColor = useColorModeValue('gray.200', 'whiteAlpha.100');

  return (
    <Card p="30px">
      <Text color={textColor} fontSize="xl" fontWeight="700" mb="20px">
        Plan Features ({features.length})
      </Text>
      {features.length === 0 ? (
        <Text color="gray.500" fontSize="sm">
          No features configured for this plan
        </Text>
      ) : (
        <Table variant="simple" size="sm">
          <Thead>
            <Tr>
              <Th borderColor={borderColor}>Name</Th>
              <Th borderColor={borderColor}>Label</Th>
              <Th borderColor={borderColor}>Count</Th>
              <Th borderColor={borderColor}>Price (ILS)</Th>
              <Th borderColor={borderColor}>Visible</Th>
              <Th borderColor={borderColor}>Order</Th>
            </Tr>
          </Thead>
          <Tbody>
            {features.map((feature) => (
              <Tr key={feature.id || feature.name}>
                <Td borderColor={borderColor}>
                  <Text color={textColor} fontSize="sm" fontWeight="500">
                    {feature.name}
                  </Text>
                </Td>
                <Td borderColor={borderColor}>
                  <Text color={textColor} fontSize="sm">
                    {feature.label}
                  </Text>
                </Td>
                <Td borderColor={borderColor}>
                  <Text color={textColor} fontSize="sm">
                    {feature.variables?.count ?? '-'}
                  </Text>
                </Td>
                <Td borderColor={borderColor}>
                  <Text color={textColor} fontSize="sm">
                    {feature.variables?.price?.ils != null
                      ? `${feature.variables.price.ils}`
                      : '-'}
                  </Text>
                </Td>
                <Td borderColor={borderColor}>
                  <Badge
                    colorScheme={feature.visible ? 'green' : 'gray'}
                    fontSize="xs"
                    borderRadius="6px"
                  >
                    {feature.visible ? 'Yes' : 'No'}
                  </Badge>
                </Td>
                <Td borderColor={borderColor}>
                  <Text color={textColor} fontSize="sm">
                    {feature.order ?? '-'}
                  </Text>
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      )}
    </Card>
  );
}
